interface PageHeaderProps {
  title: string;
  description: string;
}

export const PageHeader = ({ title, description }: PageHeaderProps) => {
  return (
    <div className="mt-9 mb-6">
      <h2 className="text-xl font-semibold text-content-on-dark-default">{title}</h2>
      <h3 className="">{description}</h3>
    </div>
  );
};
